import { CurrencyPipe, KeyValuePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { AccountBalances, BaseUser, CreditAccount } from '@enrollhere/classes';
import { SortAlphabeticallyKeyValuePipe } from '../../../services/account/pipes/sort-alphabetically.pipe';
import { UserCardComponent } from '../../ui-components/user-card/user-card.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faEye, faExchangeAlt } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-account-balances-detail',
  standalone: true,
  imports: [
    CurrencyPipe,
    FaIconComponent,
    KeyValuePipe,
    SortAlphabeticallyKeyValuePipe,
    UserCardComponent,
  ],
  templateUrl: './account-balances-detail.component.html',
  styleUrl: './account-balances-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AccountBalancesDetailComponent {
  @Input() accounts?: CreditAccount[];
  @Input() balances?: AccountBalances;
  @Input() userId?: string;
  @Input() showOwner: boolean = false;
  @Input() owner?: BaseUser;
  @Input() showUserCards: boolean = false;
  @Output() ownerToggle = new EventEmitter<void>();
  @Output() viewDetails = new EventEmitter<{
    accountId: string;
    accountData: any;
  }>();
  @Output() transfer = new EventEmitter<{
    accountId: string;
    accountData: any;
  }>();

  // Icons
  faEye = faEye;
  faExchangeAlt = faExchangeAlt;

  onOwnerToggle() {
    this.ownerToggle.emit();
  }

  onViewDetails(accountId: string, accountData: any) {
    this.viewDetails.emit({ accountId, accountData });
  }

  onTransfer(accountId: string, accountData: any) {
    this.transfer.emit({ accountId, accountData });
  }
}
